
import React from 'react';
import { format, isSameDay } from 'date-fns';
import { hu } from 'date-fns/locale';
import { Event } from '@/lib/types';
import { getEventsForDay } from '@/utils/eventUtils';
import { CalendarSlot } from '@/utils/calendarSlots';

interface CalendarDaysHeaderProps {
  slots: CalendarSlot[];
  cellWidth: number;
  filteredEvents: Event[];
}

const CalendarDaysHeader = ({ slots, cellWidth, filteredEvents }: CalendarDaysHeaderProps) => {
  const today = new Date();

  return (
    <div className="flex bg-medihub-headerBg rounded-t-lg shadow-sm font-sans">
      {slots.map((slot, slotIndex) => {
        if (slot.type === 'gap') {
          return (
            <div
              key={`header-gap-${slotIndex}`}
              className="py-3 px-2 text-center border-b border-r last:border-r-0 border-medihub-midPurple/30"
              style={{
                width: `${cellWidth}px`,
                minWidth: `${cellWidth}px`,
                maxWidth: `${cellWidth}px`,
              }}
            >
              <div className="text-medihub-secondary/60 text-xs font-medium">
                {slot.spanDays} nap
              </div>
              <div className="text-gray-400 font-semibold text-lg leading-none">⋯</div>
              <div className="text-xs text-medihub-secondary/50">üres</div>
            </div>
          );
        }

        const day = slot.day;
        const eventsForDay = getEventsForDay(filteredEvents, day);
        const hasEventsForDay = eventsForDay.length > 0 || !slot.isEmpty;
        const isToday = isSameDay(day, today);

        return (
          <div
            key={`header-${slotIndex}`}
            className={`py-3 px-2 font-medium text-center border-b border-r last:border-r-0 border-medihub-midPurple/30
              ${isToday ? 'bg-medihub-softGray/70' : ''}
              ${!hasEventsForDay ? 'text-medihub-secondary/80' : ''}`}
            style={{
              width: `${cellWidth}px`,
              minWidth: `${cellWidth}px`,
              maxWidth: `${cellWidth}px`,
            }}
          >
            <div className={`text-medihub-secondary text-xs font-medium ${isToday ? 'font-bold' : ''}`}>
              {format(day, 'EEEE', { locale: hu })}
            </div>
            <div className={`${isToday ? 'text-medihub-primary font-bold text-lg' : hasEventsForDay ? 'text-gray-900' : 'text-gray-500'} font-semibold text-lg`}>
              {format(day, 'd', { locale: hu })}
            </div>
            <div className={`text-xs ${isToday ? 'text-medihub-primary font-bold' : 'text-medihub-secondary/80'}`}>
              {format(day, 'MMM', { locale: hu })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CalendarDaysHeader;
